
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': '테스트',
	'visualizationSlideoutTitle': '시각화',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': '숫자 입력',
	'maxValuePlaceholder': '숫자 입력',
	'customRangeErrorMessage': '값은 숫자여야 함',
	'propFillColor': '채우기 색상',
	'propBorderColor': '테두리 색상',
	'propColorPalette': '현재 색상표',
	'propColorPaletteChangeLabel': '색상표 변경',
	'propNewColorPaletteLabel': '사용자 정의 색상표 작성',
	'propNewHeatPaletteLabel': '사용자 정의 히트 색상표 작성',
	'propDonutRadius': '도넛형 방사형',
	'showTitleLabel': '제목 표시',
	'titleTypeLabel': '제목 유형',
	'smartTitleLabel': '스마트 제목',
	'customTitleLabel': '사용자 정의 제목',
	'noTitleLabel': '제목 없음',
	'propHeatScalePalette': '현재 히트 색상표',
	'propHeatPaletteChangeLabel': '히트 색상표 변경',
	'propMaintainAxisScales': '축 눈금 유지',
	'propLineAndSymbolColor': '선 및 기호 색상',
	'propLineAndSymbolPalette': '선 및 기호 색상표',
	'propElementColor': '요소 색상',
	'propColumnColor': '열 색상',
	'propColumnPalette': '열 색상표',
	'propColumnHeatPalette': '열 히트 색상표',
	'propBarColor': '막대 색상',
	'propGoalColor': '대상 색상',
	'propToColor': '종료 색상',
	'propFromColor': '시작 색상',
	'propNumberValidationErrorMessageId': '숫자 입력',
	'fontSizeAuto': '자동',
	'propAutoBinCount': '그룹 수',
	'propAutoBinToggle': '자동 그룹화',
	'tabName_general': '일반',
	'tabName_visDetails': '세부사항',
	'tabName_animation': '애니메이션',
	'tabName_mediaDetails': '매체 세부사항',
	'tabName_webDetails': '웹 페이지 세부사항',
	'tabName_imageDetails': '이미지 세부사항',
	'tabName_visualization': '시각화',
	'tabName_text': '텍스트',
	'sectionName_colorsAndThemes': '색상 및 테마',
	'sectionName_appearance': '모양',
	'sectionName_general': '일반',
	'sectionName_colorPalette': '색상',
	'sectionName_axis': '축',
	'sectionName_axis_label': '축',
	'sectionName_legend': '범례',
	'sectionName_chart': '차트',
	'sectionName_regionLayer': '영역 계층',
	'sectionName_pointLayer': '지점 계층',
	'sectionName_latLongLayer': '위도/경도 계층',
	'sectionName_pathLayer': '경로 계층',
	'sectionName_xAxis': 'X축',
	'sectionName_yAxis': 'Y축',
	'sectionName_xAxis_title': 'X축 제목',
	'sectionName_yAxis_title': 'Y축 제목',
	'sectionName_xAxis_label': 'X축 레이블',
	'sectionName_yAxis_label': 'Y축 레이블',
	'sectionName_column_yAxis': '열 Y축',
	'sectionName_column_yAxis_label': '열 Y축 레이블',
	'sectionName_column_yAxis_title': '열 Y축 제목',
	'sectionName_line_yAxis': '선 Y축',
	'sectionName_line_yAxis_label': '선 Y축 레이블',
	'sectionName_line_yAxis_title': '선 Y축 제목',
	'sectionName_title': '제목',
	'sectionName_dataValueLabels': '데이터 값 레이블',
	'sectionName_style': '스타일',
	'propTransparencyDescription': '오브젝트의 투명도를 높이거나 낮추십시오. 0 - 100 사이의 값으로 입력하십시오.',
	'smart_annotation_unauthorized': '어노테이션: 무단 액세스',
	'smart_annotation_method': '어노테이션: 허용되지 않은 방법',
	'smart_annotation_media': '어노테이션: 매체 유형이 허용되지 않음',
	'smart_annotation_input': '어노테이션: 올바르지 않은 입력',
	'smart_annotation_internal': '어노테이션: 내부 시스템 오류',
	'smart_annotation_generic_error': '어노테이션: 서비스 오류',
	'smart_annotation_dialog_title': '인사이트',
	'smart_annotation_Show_Insights': '인사이트 표시',
	'smart_annotation_Relationship': '관계:',
	'forecast_enter_number': '다음 범위의 숫자 입력 ',
	'and': ' 및 ',
	'smart_errors': '어노테이션 오류:',
	'smart_warnings': '어노테이션 경고:',
	'smart_annotation_insight_icon_title': '인사이트',
	'smart_annotations_toggle_on': '인사이트 설정',
	'smart_annotations_toggle_off': '인사이트 해제',
	'smart_annotation_toggle_on': '토글 켜기',
	'smart_annotation_toggle_off': '토글 끄기',
	'smart_annotation_insight_unavailable': '인사이트를 현재 사용할 수 없음',
	'smart_annotation_insight_topBottom_percent_unsupported': '맨 위 또는 맨 아래 % 필터가 적용되면 인사이트를 사용할 수 없음',
	'smart_annotation_forecast_topBottom_percent_unsupported': '맨 위 또는 맨 아래 % 필터가 적용되면 예측을 사용할 수 없음',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': '맨 위 또는 맨 아래 필터가 적용되고 필드에 둘 이상의 열이 있는 경우 인사이트를 사용할 수 없음',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': '맨 위 또는 맨 아래 필터가 적용되고 필드에 둘 이상의 열이 있는 경우 예측을 사용할 수 없음',
	'forecast_title': '예측',
	'forecast_show': '예측 표시',
	'forecast_toggle_on': '예측 설정',
	'forecast_toggle_off': '예측 해제',
	'statDetailsPerspectiveTitle': '분석',
	'emptyStatDetailsPanel': '현재 시각화에 대해 사용 가능한 추가 분석이 없습니다.',
	'predict_errors': '분석 오류',
	'predict_warnings': '분석 경고',
	'fpd_invalid_data_source': '이 데이터 소스에는 연관된 스마트 모듈이 없습니다.',
	'fpd_network_issue': '이 데이터 소스에 대해 분석을 수행하는 데 문제가 있습니다.',
	'fpd_data_source_category': '스마트 모듈이 누락됨',
	'fpd_response_errors': '권장되는 드라이버 오류',
	'fpd_response_warnings': '권장되는 드라이버 경고',
	'catalyst_service_bad_request': '잘못된 요청',
	'catalyst_service_unkown_Id': '알 수 없는 요청 ID를 찾음',
	'catalyst_service_internal_server_error': '내부 서버 오류',
	'catalyst_service_generic_error': 'Catalyst 서비스 오류',
	'catalyst_service_error': '이 서비스는 현재 사용할 수 없음',
	'propLegendPosition': '범례 위치',
	'propLeft': '왼쪽',
	'propRight': '오른쪽',
	'propTop': '상위',
	'propBottom': '하위',
	'propNone': '없음',
	'propLegendDisplay': '범례 표시',
	'targetThicknessPlaceHolder': '%{min} - %{max}',
	'targetThicknessErrorMsg': '%{min} 및 %{max} 사이의 정수를 입력합니다.',
	'possibleKeyDriver_DialogDriversLabelBegin': '드라이버(',
	'possibleKeyDriver_DialogDriversLabelEnd': '선택됨)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': '기본값으로 재설정',
	'possibelKeyDriver_AddNewDrivers': '드라이버 계속 추가',
	'possibleKeyDrivers_NonRecommended_Placeholder': '계속 추가할 드라이버 검색',
	'possibleKeyDrivers_MaxPossibleReached': '일부 드라이버 추가를 취소하거나 기타 드라이버 선택',
	'possibleKeyDrivers_Recommended': '권장됨',
	'visRecommendedTypes': '권장되는 시각화 유형',
	'visRecommender_smartsfailure': '시각화 권장사항은 현재 사용할 수 없습니다.',
	'visMore': '자세히...',
	'visMoreTooltip': '추가 시각화',
	'visOtherTypes': '기타 시각화 유형',
	'visChange': '시각화 변경',
	'automaticTypeCaption': '자동',
	'propVisType': '시각화 유형',
	'dlg_loading': '로드 중...',
	'snippetListChartCaption': '스니펫 목록',
	'convoClusterChartCaption': '대화 클러스터',
	'areaChartCaption': '영역형',
	'barChartCaption': '막대형',
	'columnChartCaption': '열',
	'stackedbarChartCaption': '누적 막대형',
	'stackedcolumnChartCaption': '누적 세로 막대형',
	'bubbleChartCaption': '거품형',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': '드라이버 분석',
	'scatterChartCaption': '분산형',
	'lineChartCaption': '꺾은선형',
	'pointChartCaption': '포인트형',
	'heatChartCaption': '히트맵',
	'bulletChartCaption': '글머리 기호',
	'waterfallChartCaption': '워터폴',
	'radarChartCaption': '방사형',
	'boxplotChartCaption': '상자 그림',
	'pieChartCaption': '원형',
	'mapChartCaption': '맵',
	'radialBarChartCaption': '방사형',
	'compositeChartCaption': '선 및 열',
	'wordCloudChartCaption': '단어 클라우드',
	'networkChartCaption': '네트워크',
	'relationshipNetworkChartCaption': '관계 네트워크',
	'treemapChartCaption': '트리맵',
	'packedBubbleChartCaption': '압축 거품',
	'hierarcicalPackedBubbleChartCaption': '계층 구조 거품',
	'spiralChartCaption': '나선형',
	'decisionTreeChartCaption': '의사결정 트리',
	'legacyMapChartCaption': '레거시 맵',
	'sunburstChartCaption': '선버스트',
	'visUsageComparison': '비교',
	'visUsageRelationships': '관계',
	'visUsageTrend': '추세',
	'visUsagePartsToWhole': '일부 대 전부',
	'visUsageGeospatial': '지리공간적',
	'visUsageAdvanced': '고급 분석',
	'visUsageTablesAndSummary': '테이블 및 요약',
	'visUsageSocialInsights': '소셜 인사이트',
	'visUsageOther': '기타',
	'autoBinActionText': '자동 그룹화',
	'filterAutobinActionText': '구간 필터',
	'memberCalculationActionText': '멤버 계산',
	'toolbarActionCalculation': '계산 작성',
	'toolbarActionEditCalculation': '계산 편집',
	'topBottomRankLabel': '등급(%{label})',
	'toolbarDeleteFilterActionText': '필터 제거',
	'toolbarActionTopKeyDrivers': '드라이버 표시',
	'toolbarActionCustomGroup': '사용자 정의 그룹',
	'canNotCreateCustomGroup': '이 사용자 정의 그룹을 작성할 수 없습니다.',
	'aria_label_datatable': '데이터 테이블',
	'summaryCaption': '요약',
	'MeasuresCaption': '측정값',
	'MeasuresGroupCaption': '측정값 그룹(%{count})',
	'ValuesCaption': '값',
	'turnInsightsOn': '인사이트 설정',
	'turnInsightsOff': '인사이트 해제',
	'decisionRules': '규칙',
	'decisionTree': '트리 다이어그램',
	'decisionSunburst': '트리 선버스트',
	'switchToDecisionRules': '의사결정 규칙으로 전환',
	'switchToDecisionTree': '의사결정 트리로 전환',
	'data_group_less_then': '%{rangeTo} 미만',
	'data_group_to': '%{rangeFrom} - < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} 이상',
	'nullValueContent': '(값 없음)',
	'sum': '합계',
	'count': '개수',
	'countdistinct': '고유 수',
	'avg': '평균값',
	'min': '최소값',
	'max': '최대값',
	'automatic': '사용자 정의',
	'variance': '분산',
	'stddev': '표준 편차',
	'median': '중앙값',
	'calculated': '계산됨',
	'none': '없음',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': '프롬프트 값',
	'inputLabelPrompt': '값',
	'inputPlaceholderPrompt': '값 입력',
	'inputInvalidText': '%{dataType} 유형에 대한 올바르지 않은 입력',
	'unSupportedPrompt': '지원되지 않는 프롬프트',
	'missingDataSource': '올바른 데이터 소스를 찾을 수 없습니다.',
	'unSupportedPromptType': '프롬프트 시나리오는 현재 지원되지 않습니다.',
	'preAggregateLabel': '데이터 소스에서 프롬프트 값 적용',
	'postAggregateLabel': '보고서에서 프롬프트 값 적용',
	'preAggregateText': '이 범위에서는 대시보드에 표시된 값이 아닌 데이터 소스의 값을 사용합니다.',
	'defaultAggregation_count': '개수',
	'defaultAggregation_countdistinct': '고유 수',
	'defaultAggregation_max': '최대값',
	'defaultAggregation_min': '최소값',
	'defaultAggregation_avg': '평균값',
	'defaultAggregation_sum': '합계',
	'defaultAggregation_auto': '자동(%{aggregationType})',
	'keydriver_average': '전체 평균',
	'keydriver_up_down': '평균이 높거나 낮은 강조표시된 그룹은 대상에 더 큰 영향을 미칩니다. 평균이 비정상적으로 높거나 낮은 그룹이 가장 큰 영향을 줍니다.',
	'keydriver_different': '강조표시된 그룹의 분포가 전체 분포와 매우 다릅니다. 이러한 그룹이 대상에 더 큰 영향을 미칩니다.',
	'topOperator': '상위',
	'bottomOperator': '하위',
	'topBottomFact': '%{operator} %{value}%{percent}, 기준: %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': '상위 또는 하위 개수 삭제',
	'deleteTopBottomPercent': '상위 또는 하위 % 삭제',
	'topBottomTitle': '이 오브젝트만',
	'deleteTopBottom': '상위 또는 하위 개수 삭제',
	'editTopBottom': '상위 또는 하위 개수 편집',
	'editTopBottomCount': '상위 또는 하위 개수 편집',
	'editTopBottomPercent': '상위 또는 하위 % 편집',
	'ariaDeleteTopBottomCountLabel': '상위 또는 하위 개수를 삭제하려면 DELETE 키를 누르십시오.',
	'ariaDeleteTopBottomPercentLabel': '상위 또는 하위 개수를 삭제하려면 DELETE 키를 누르십시오.',
	'ariaEditTopBottomCountLabel': '상위 또는 하위 개수를 편집하려면 ENTER 키를 누르십시오.',
	'ariaEditTopBottomPercentLabel': '상위 또는 하위 %를 편집하려면 ENTER 키를 누르십시오.',
	'ariaDeleteDrillStateLabel': '상위 또는 하위 개수를 편집하려면 ENTER 키를 누르십시오.',
	'drillUpStateTitle': '드릴 업',
	'drillDownStateTitle': '드릴 다운',
	'ariaEditTopBottomLabel': '상위 또는 하위 개수를 편집하려면 ENTER 키를 누르십시오.',
	'ariaDeleteTopBottomLabel': '상위 또는 하위 개수를 삭제하려면 DELETE 키를 누르십시오.',
	'allKeyDriversLabel': '자동(모든 드라이버)',
	'filter_drag_and_drop_single_dock': '필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filter_drag_and_drop_all_tabs': '모든 탭을 필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filter_drag_and_drop_current_tab': '이 탭을 필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filter_empty_consume_mode': '필터가 적용되지 않았습니다.',
	'filterClearAllItems': '필터 모두 지우기',
	'filterDeleteAllItems': '필터 모두 삭제',
	'filterDockChevronLeft': '데이터를 통해 스크롤',
	'filterDockChevronRight': '데이터를 통해 스크롤',
	'filterIconLabel_Single': '필터',
	'filterIconLabel_Global': '모든 탭',
	'filterIconLabel_Tab': '이 탭',
	'filterIconTooltip_Single': '필터',
	'filterIconTooltip_Global': '모든 탭에 대한 필터',
	'filterIconTooltip_Tab': '이 탭에 대한 필터',
	'filterDropZoneTooltip_Single': '필터 끌어놓기 영역',
	'filterDropZoneTooltip_Global': '모든 탭에 대한 필터 끌어놓기 영역',
	'filterDropZoneTooltip_Tab': '이 탭에 대한 필터 끌어놓기 영역',
	'filterOverflowMenu': '자세히',
	'expand': '펼치기',
	'collapse': '접기',
	'filterDockItemNameAriaLabel': '필터 대화상자를 시작하고 필터를 정의하려면 Enter를 누르십시오.',
	'filterItemCanvasMove': '캔버스에 추가',
	'filterItemDelete': '필터 삭제',
	'filterInvertRange': '다음을 제외한 모두: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': '%{from} 이후 제외',
	'filter_date_after': '%{from} 이후',
	'filter_date_before_except': '%{to} 이전 제외',
	'filter_date_before': '%{to} 이전',
	'filter_date_between_except': '%{from}-%{to} 범위 제외',
	'filter_date_between': '%{from}-%{to} 범위',
	'filterValueSeparator': ',',
	'filterAll': '모두',
	'filter': '필터',
	'filterExcept': '%{values} 제외',
	'filterDockToolbarButtonLabel': '필터 도크',
	'navigateTitle': '이동 위치',
	'navigateSelectColumn': '열 선택',
	'navigateSelectPath': '탐색 경로 선택',
	'current_nav_group': '현재 탐색 그룹은 %{navigation_group_name}임',
	'next': '다음',
	'previous': '이전',
	'multiselectMsg': '%{count}이(가) 선택됨',
	'errMsgFilterItemMissingTitle': '필터 값 %{itemName}은(는) 해당 값이 이 데이터 세트에 사용 가능하지 않아 로드할 수 없습니다.',
	'errMsgFilterItemGenericTitle': '필터 값을 로드할 수 없음',
	'textFilterItemsNotFound': '사용 가능한 항목이 없습니다.',
	'nullValueLabel': '(공백)',
	'filterConditionLabel': '필터 조건',
	'filter_includesAll': '모두 포함',
	'filter_allMembersOfSet': '세트의 모든 멤버',
	'modelFilter': '필터',
	'filtersTitle': '필터 특성',
	'search': '검색',
	'clearTextFilterValue': '지우기',
	'invertFilterSelection': '반전',
	'modellingLoading': '로드 중...',
	'searchAll': '모든 열 찾기',
	'toolbarActionPossibleKeyDrivers': '범위 편집',
	'toolbarActionPossibleKeyDriversSubTitle': '드라이버 분석 차트에서 고려할 항목을 왼쪽에서 끌어오십시오.',
	'toolbarActionSort': '정렬',
	'toolbarActionSortAscending': '오름차순',
	'toolbarActionSortDescending': '내림차순',
	'toolbarActionSortAuto': '자동(%{sortOrder})',
	'toolbarActionSortCustom': '사용자 정의',
	'toolbarActionFormat': '데이터 형식화',
	'toolbarActionFormatText': '데이터 형식화(텍스트)',
	'toolbarActionFormatAbbreviation': '축약',
	'toolbarActionFormatNone': '자동',
	'toolbarActionFilter': '필터',
	'toolbarActionTopBottom': '맨 위 또는 맨 아래',
	'toolbarActionRmvShape': '모양 제거',
	'toolbarActionToggleShapeDrop': '인포그래픽 모양',
	'toolbarActionToggleShapeDropTitle': '인포그래픽 작성',
	'toolbarActionToggleShapeDropText': '인포그래픽을 작성하려면 모양을 이 필드로 끄십시오.',
	'toolbarActionAggregationType': '요약',
	'toolbarDeleteActionText': '열 제거',
	'toolbarTextActionText': '스타일 텍스트',
	'toolbarActionFilterLocalKeepSelected': '유지',
	'toolbarActionFilterLocalExcludeSelected': '제외',
	'toolbarActionFilterAllKeepSelected': '필터',
	'toolbarActionSimpleCalculation': '단순 계산',
	'toolbarActionDrillBack': '이전',
	'toolbarActionDrillUp': '드릴 업',
	'toolbarActionDrillDown': '드릴 다운',
	'toolbarActionJumpTo': '드릴 스루',
	'toolbarActionNavigate': '탐색',
	'toolbarActionCreateFilterGroup': '새 연결 작성',
	'toolbarActionDisconnectFilterGroup': '모든 링크 구분',
	'toolbarActionLinkFilterGroup': '기존 연결에 추가',
	'toolbarActionLassoSelect': '도구 선택',
	'toolbarActionRefreshDeveloperWidget': '새로 고치기',
	'textFontFamilySubClassHairline': '헤어라인',
	'textFontFamilySubClassThin': '얇음',
	'textFontFamilySubClassThinItalic': '얇은 기울임꼴',
	'textFontFamilySubClassExtraLight': '매우 미세함',
	'textFontFamilySubClassExtraLightItalic': '매우 미세한 기울임꼴',
	'textFontFamilySubClassLight': '밝음',
	'textFontFamilySubClassLightItalic': '미세한 기울임꼴',
	'textFontFamilySubClassRegular': '정기',
	'textFontFamilySubClassRegularItalic': '일반 기울임꼴',
	'textFontFamilySubClassItalic': '기울임꼴',
	'textFontFamilySubClassMedium': '중간',
	'textFontFamilySubClassMediumItalic': '중간 기울임꼴',
	'textFontFamilySubClassHeavy': '진함',
	'textFontFamilySubClassHeavyItalic': '진한 기울임꼴',
	'textFontFamilySubClassDemiBold': '반굵게',
	'textFontFamilySubClassDemiBoldItalic': '반굵게 기울임꼴',
	'textFontFamilySubClassBold': '굵게',
	'textFontFamilySubClassBoldItalic': '굵게 기울임꼴',
	'textFontFamilySubClassExtraBold': '매우 굵게',
	'textFontFamilySubClassExtraBoldItalic': '매우 굵게 기울임꼴',
	'textFontFamilySubClassBlack': '검은색',
	'textFontFamilySubClassBlackItalic': '검게 기울임꼴',
	'textFontFamilySubClassStencil': '스텐실',
	'dlg_ascending': '오름차순',
	'dlg_descending': '내림차순',
	'dlg_custom': '사용자 정의',
	'dlg_none': '없음',
	'dlg_hierarchy': '계층 구조',
	'dlg_namedSet': '이름 지정된 세트',
	'dlg_rank': '등급',
	'visualizationLabel': '시각화',
	'chartLabel': '%{chartName} 차트',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': '위젯 내에서 탐색하려면 F12를 누르십시오.',
	'f10KeyDescription': '위젯 포커스 보기를 시작하려면 F10을 누르십시오.',
	'playButtonLabel': '재생',
	'dataPlayerValueListLabel': '데이터 재생기 값',
	'localFilterTitle': '이 오브젝트만',
	'globalFilterTitle': '모든 오브젝트',
	'deleteFilter': '필터 삭제',
	'editFilter': '필터 편집',
	'ariaEditFilterLabel': '필터를 편집하려면 ENTER 키를 누르십시오.',
	'ariaDeleteFilterLabel': '필터를 삭제하려면 DELETE 키를 누르십시오.',
	'measureFilterBetween': '%{lowerBound} 및 %{upperBound} 범위',
	'measureFilterNotBetween': '%{lowerBound} 및 %{upperBound} 범위 제외',
	'dimFilterIn': '포함: %{in}',
	'dimFilterNotIn': '제외: %{out}',
	'gtFilter': '%{lowerBound} 이후',
	'ltFilter': '%{upperBound} 이전',
	'ariaEditPrompt': '프롬프트 값을 변경하려면 ENTER 키를 누르십시오.',
	'dataPointFilterTitle': '데이터 점',
	'dataPointFilterIncludeSummary': '%{valueCount} 데이터 점 포함됨',
	'dataPointFilterExcludeSummary': '%{valueCount} 데이터 점 제외됨',
	'widgetFiltersLabel': '위젯 필터',
	'coachMarkTitleSpiralTarget': '범위 편집',
	'coachMarkContentSpiralTarget': '대상에 대한 드라이버 선택에 액세스하고 수정할 수 있는 위치입니다.',
	'srILVTreeLabel': '목록',
	'geomapUnrecognizedLocations': '인식되지 않는 위치:',
	'geomapAmbiguousLocations': '모호한 영역:',
	'visualizationNotifications': '시각화 알림:',
	'dataNotifications': '데이터 알림:',
	'autobinSuggestion': '자동 그룹화 켜기',
	'LIVE_empty_visualization_hint_title': '시각화 빌드',
	'LIVE_empty_visualization_hint_description': '여기 또는 필드에 데이터를 끕니다.',
	'LIVE_slots_required_field_description': '%{asterisk} 필수 필드 표시',
	'LIVE_slots_drag_and_drop_description': '가상화를 빌드하고 필터링하려면 위의 필드에 데이터를 끌어서 놓습니다.',
	'dwErrorLoadingAvailableVisualizations': '사용 가능한 시각화 정의를 로드할 수 없습니다.',
	'moreDataIndicator': '%{threshold} 항목에서 데이터가 클립되었습니다. 더 적게 표시하려면 필터를 적용하십시오.',
	'nonCtxTopBottomInvalid': '컨텍스트 없이 맨 위 또는 맨 아래 규칙을 정의하는 작업은 교차 분석에서 지원되지 않습니다. 이 교차 분석 뷰에서 제거되었습니다.  %{columnName}의 컨텍스트에 있는 하나 이상의 카테고리에서 규칙을 재정의합니다.',
	'dwErrorLoadingVisualizationNotFound': '오브젝트에 시각화 정의가 누락되어 해당 오브젝트를 로드할 수 없습니다.',
	'dwErrorLoadingVisualizationListNotFound': '시각화를 로드할 수 없습니다.',
	'dwErrorRunningQuery': '데이터 세트 %{datasetName}에서 데이터를 검색할 수 없습니다.',
	'dwErrorGeoData': '맵에 지리적 데이터를 표시하는 데 문제가 있습니다. 다른 시각화 유형을 선택하십시오.',
	'dwPromptSignonCancelWarning': '이 시각화의 데이터를 사용할 수 없습니다. 올바른 신임 정보를 제공하십시오.',
	'dwErrorMissingDataset': '연관 데이터 세트 "%{datasetName}"을(를) 사용할 수 없으므로 시각화를 로드할 수 없습니다.',
	'dwErrorRenderingVisualization': '이 시각화를 로드할 수 없습니다.',
	'dwErrorVisualizationTooSmall': '포함된 데이터를 표시하기에 시각화의 크기가 너무 작습니다. 시각화 크기를 늘리거나 시각화에 포함되는 데이터를 제한하십시오.',
	'errorSourceNotFound': '연관 소스 "%{sourceName}"을(를) 사용할 수 없으므로 시각화를 로드할 수 없습니다.',
	'errorActionNotSupported': '이 조치는 데이터 소스 "%{sourceName}"에 대해 지원되지 않습니다.',
	'errorMeasureNotSupportedOnMultiEdges': '시각화가 여러 에지에 측정값을 포함합니다. 이는 더 이상 지원되지 않습니다. 하나의 에지에만 측정값을 배치하십시오.',
	'errorExceedAllowableValue': '예상 셀 수가 허용 가능한 값인 100000개를 초과합니다. 예상 세트에 필터링을 적용하여 셀 수를 줄이십시오.',
	'propScaleLabel': '아이콘 수량',
	'propScaleDescription': '아이콘 수량을 선택하십시오.',
	'propScaleFew': '낮음',
	'propScaleDefault': '기본값',
	'propScaleMany': '높음',
	'lastRefresh': '마지막 새로 고치기: %{timeInterval} 전',
	'widgetTimer': '위젯 타이머',
	'datasetItemsUnavailable': '이 시각화에 사용된 일부 데이터 세트 항목을 사용할 수 없습니다.',
	'datasetItemUnavailable': '이 데이터 세트 항목을 사용할 수 없음',
	'retry': '재시도',
	'widgetConditionalFormatLabel': '조건부 형식 제어 토글',
	'widgetConditionalFormatTitle': '조건부 형식 색상 편집',
	'crosstabName': '교차 분석',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': '해당사항 없음',
	'summaryLabel': '%{label}(값 %{value} 포함)',
	'infographicLabel': '%{label}(값 %{value} 포함)',
	'warning': '경고',
	'swapRowsAndColumns': '행과 열 바꾸기',
	'hideSummariesLabel': '요약 숨기기',
	'showSummariesLabel': '요약 표시',
	'hideRowColumn': '숨기기',
	'showAllRowColumn': '모두 표시',
	'dataAssetPropertiesLabel': '시각화 특성',
	'evAdd': '열 추가',
	'evCollapse': '접기',
	'evColumns': '열',
	'evLocalFilters': '로컬 필터',
	'evExpand': '펼치기',
	'evFilterTooltip': '필터',
	'missingColumn': '누락: %{columnLabel}',
	'missingFiltering': '열에 대한 필터가 누락됨:',
	'missingDataItem': '참조된 데이터 항목 "%{dataItemId}"을(를) 위젯에서 찾을 수 없습니다.',
	'heatByLabel': '히트 기준',
	'toolbarChangeVisualization': '시각화 변경',
	'modellingRelatedTablesNoneFound': '관련된 테이블을 찾을 수 없음',
	'processing': '처리 중...',
	'errorCellWarning': '일부 요약 값을 계산할 수 없습니다.',
	'aggregateTypeToggler': '집계 유형 표시',
	'maxColumnsExceeded': '최대 열 수가 초과되었습니다. %{columns}이(가) 삭제되었습니다.',
	'unboundColumns': '다음 열을 사용할 수 없음: %{columns}.',
	'unboundColumn': '다음 열을 사용할 수 없음: %{columns}.',
	'recommendRequestFailed': '권장 요청이 실패했습니다. 관리자에게 문의하십시오.',
	'visualizationDoesNotSupportOLAP': 'OLAP 데이터 소스를 기반으로 하는 이 시각화를 작성할 수 없습니다. 지원되는 다른 데이터 소스를 사용하십시오.',
	'showDataBehindVizLabel': '데이터 표시',
	'showDataBehindVizNotSupportedLabel': '이 시각화 유형에는 데이터 표시가 지원되지 않음',
	'exploreData': '탐색...',
	'newExplore': '새 탐색',
	'thumbnails_error_fetching': '축소 그림 페치 오류',
	'loadedThumbnailImage': '로드된 %{visType} 시각화 축소 그림 이미지',
	'autobinAxisLabel': '그룹',
	'recommended_visualizations': '권장되는 시각화',
	'all_visualizations': '모든 시각화',
	'edit': '편집',
	'selectTargetDialogTitle': '드릴 스루 대상 선택',
	'noTargetInCM': '드릴 스루 대상을 찾을 수 없음',
	'errorDrillDefinition': '드릴 스루 정의 추가 또는 편집 중에 문제가 발생했습니다.',
	'errorDrillToTarget': '"%{targetName}"(으)로 드릴하는 동안 오류가 발생했습니다.',
	'drillThroughMappingViewLabel': '대시보드에서 대상 보고서의 프롬프트로 열 지정',
	'drillthroughScopeRadioLabel': '다음에 이 정의 적용:',
	'drillthroughScopeRadioOptionVisualization': '이 시각화만',
	'drillthroughScopeRadioOptionConnection': '동일한 데이터 소스를 사용하는 동일한 연결의 시각화',
	'drillthroughScopeRadioOptionDashboard': '동일한 데이터 소스를 사용하는 %{perspective}의 모든 시각화',
	'drillThroughParametersColumnTitle': '"%{targetName}" 프롬프트:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" 데이터 열:',
	'drillThroughDefinitionNoParameter': '드릴 스루 대상에 프롬프트가 없습니다.',
	'drillThroughDefinitionErrorQueryingReport': '대상 보고서의 문제점을 정정한 후 다시 시도하여 드릴 스루 정의를 작성하십시오.',
	'drillThroughDefinitionErrorDlgTitle': '문제 발생',
	'dlg_back': '되돌아가기',
	'dlg_close': '닫기',
	'dlg_ok': '확인',
	'dlg_cancel': '취소',
	'dlg_apply': '적용',
	'dlg_create': '작성',
	'dlg_done': '완료',
	'drillthrough_unsaveMsg': '"%{name}"을(를) 저장하지 않고 계속하시겠습니까?',
	'drillthrough_jumpTo': '드릴 스루 정의: %{name}',
	'drillthrough_jumpToLabel': '드릴 스루',
	'drillthrough_manage': '관리...',
	'drillthrough_addNewTarget': '새 드릴 스루 정의 추가',
	'drillthrough_manageJumpPaths': '드릴 스루 정의 관리',
	'drillthrough_manageJumpPaths_edit': '"%{name}" 편집',
	'drillthrough_manageJumpPaths_delete': '"%{name}" 삭제',
	'drillthrough_manageAddAnotherTarget': '다른 드릴 스루 정의 추가',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': '삭제 확인',
	'drillthrough_manageConfirmeDeleteDrillTarget': '드릴 스루 "%{name}"을(를) 삭제하시겠습니까?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': '드릴 스루 이름 중복',
	'drillthrough_definitionMessage': '드릴 스루 "%{name}"이(가) 이미 있습니다. 다른 이름을 지정하십시오.',
	'drillthrough_jumpToTarget_notFound': '드릴 스루 "%{name}"에 대한 대상을 찾을 수 없음',
	'drillThroughDefinitionNoParameterSubTitle': '대상 보고서에 컨텍스트가 전달되지 않습니다.',
	'drillthrough_titleLabel': '이름',
	'drillthrough_create_dialogTitle': '드릴 스루 정의 작성',
	'drillthrough_edit_dialogTitle': '드릴 스루 정의 편집',
	'drillthrough_subTitle': '소스에 있는 시각화의 컨텍스트가 대상 %{perspective}을(를) 필터링하는 데 사용됩니다.',
	'drillthrough_selectColumn': '열 선택',
	'noPrompt': '프롬프트 없음',
	'promptDialog': '%{promptType} 프롬프트 대화 상자',
	'formatAutoDescription': '자동은 데이터 소스 또는 시각화에서 상속한 형식을 지정합니다.',
	'formatDefaultDescription': '기본값은 시스템에서 상속한 형식을 지정합니다.',
	'createCustomGroupAction': '데이터 그룹 작성',
	'removeCustomGroupAction': '데이터 그룹 제거',
	'editCustomGroupAction': '데이터 그룹 편집',
	'renameCustomGroupAction': '데이터 그룹 이름 바꾸기',
	'createCustomGroupErrorToast': '데이터 그룹을 작성할 수 없습니다.',
	'removeCustomGroupErrorToast': '데이터 그룹을 제거할 수 없습니다.',
	'editCustomGroupErrorToast': '데이터 그룹을 편집할 수 없습니다.',
	'renameCustomGroupErrorToast': '데이터 그룹의 이름을 바꿀 수 없습니다.',
	'customGroupLabel': '데이터 그룹 작성',
	'ungroupCustomGroupLabel': '그룹화 해제',
	'renameCustomGroupLabel': '이름 바꾸기',
	'createCustomGroupLabel': '작성',
	'customGroupingLabel': '%{columnLabel}(그룹)',
	'createCustomSort': '사용자 정의 정렬 작성',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': '사용 가능한 항목을 선택한 후 다시 정렬하여 사용자 정의 정렬을 작성하십시오.',
	'availableItems': '사용 가능한 항목',
	'selectAll': '모두 선택',
	'customSortOrder': '사용자 정의 정렬 순서',
	'selectAvailableItemsDesc': '사용 가능한 항목을 선택한 후 여기에서 다시 정렬하십시오.',
	'moveToTop': '맨 위로 이동',
	'clear': '지우기',
	'sortRemainingItemsBy': '다음 기준으로 나머지 항목 정렬:',
	'removeAll': '모두 제거',
	'resetTooltip': '%{customSortOrder} 목록에서 모든 항목이 제거됩니다. 또한, %{sortRemainingItemsBy} 드롭 다운이 기본값으로 돌아갑니다.',
	'manyItemsWarning': '많은 항목을 선택하면 대시보드의 성능에 영향을 미칠 수 있습니다.',
	'manyItemsSelected': '%{maxItems}개를 초과하는 항목을 선택하면 대시보드의 성능에 영향을 미칠 수 있습니다.',
	'somethingWentWrong': '죄송합니다. 잘못된 부분이 있는 것 같습니다. ',
	'tryAgain': '다시 시도',
	'customSortLabel': '사용자 정의 정렬',
	'applyError': '%{action}을(를) 적용할 수 없습니다.',
	'searchReturnedNoResults': '검색에서 결과를 리턴하지 않았습니다.',
	'extVisSystem': '시스템',
	'extVisCustom': '사용자 정의',
	'customVisTestVisualization': '테스트 시각화',
	'extVisCustomVisPreview': '미리보기',
	'extVisCustomPreviewWidgets': '개발자 위젯',
	'extVisCustomVVisualization': '시각화',
	'extVisCustomVisuals': '사용자 정의 비주얼',
	'noPermissionToManage': '사용자 정의 시각화를 관리할 권한이 없습니다.',
	'extVisCustomUpdate': '업데이트',
	'extVisCustomDelete': '삭제',
	'extVisNoCustomVisuals': '사용자 정의 비주얼 없음',
	'extVisNoCustomVisualsMsg': '현재 조직에 사용자 정의 비주얼이 없음',
	'extVisAddCustomVisual': '사용자 정의 비주얼 추가',
	'extVisNoCustomVisualsAdminMsg': '현재 사용자 정의 비주얼이 없습니다. 시작하려면 이를 추가하십시오.',
	'extVisNoSDKConnection': '로컬 파일에 대한 연결이 작성되지 않았음',
	'extVisNoSDKPreviewMsg': '시각화를 미리 보려면 연결을 설정하십시오.',
	'extVisMore': '자세히',
	'extVisDeleteDialogTitle': '사용자 정의 비주얼 삭제',
	'extVisDeleteDialogBody': '이 사용자 정의 시각화를 삭제하시겠습니까? 다른 대시보드 또는 보고서에서 사용 중일 수 있습니다.',
	'extVisDeleteConfirmation': '사용자 정의 비주얼이 삭제되었습니다.',
	'extVisDeleteError': '사용자 정의 비주얼을 삭제할 수 없습니다. %{msg}',
	'extVisCloseToast': '지금 종료',
	'extVisAdd': '사용자 정의 비주얼이 추가되었습니다.',
	'extVisAddError': '사용자 정의 비주얼을 추가할 수 없습니다. %{msg}',
	'extVisUpdate': '사용자 정의 비주얼이 업데이트되었습니다.',
	'extVisUpdateError': '사용자 정의 비주얼을 업데이트할 수 없습니다. %{msg}',
	'extVisAddProgress': '%{name} 가져오는 중',
	'extVisUpdateProgress': '%{name} 업데이트 중',
	'extPermissionTitle': '제한된 액세스 또는 삭제된 사용자 정의 비주얼',
	'extPermissionBody': '이 사용자 정의 비주얼을 삭제했거나 액세스가 제한되었기 때문에 볼 수 없습니다.',
	'customVizSaveWarning': '사용자 정의 비주얼을 저장할 수 없습니다. 이를 가져오지 않았습니다.',
	'schematicTestCaption': '테스트 스킴',
	'schematicServiceRequestError': '스킴 서비스 오류',
	'extVisPreviewMessage': '이는 미리보기입니다. 시각화가 제품에 아직 추가되지 않았습니다.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': '정의되지 않음',
	'kpiDefaultTargetLabel': '대상',
	'kpiNonNumericTarget': '대상 값이 숫자여야 합니다.',
	'kpiManualTargetSlotFilled': '필드에 적용된 값',
	'kpiAutoValueSize': '자동',
	'kpiUnableDrawSparklineLabel': '스파크라인을 그릴 수 없음',
	'kpiUnableDrawSparklineInfo': '스파크라인에 시간에 대한 최소 두 개의 지점이 있어야 합니다. 데이터를 변경하거나 필터를 조정하여 스파크라인을 확인하십시오.',
	'conditionalFormattingTextColor': '텍스트 색상',
	'suppression': '억제',
	'suppressNone': '없음',
	'suppressRowsAndColumns': '행과 열',
	'suppressRows': '행',
	'suppressColumns': '열',
	'enableSuppression': '억제 사용',
	'disableSuppression': '억제 사용 안함',
	'loadVisDefinitionError': '시각화 %{id}의 정의를 로드할 수 없음',
	'emptyVisualization': '시각화가 비어 있음',
	'expandCollapse': '펼치기 및 접기',
	'expandBtnLabel': '펼치기',
	'collapseBtnLabel': '접기',
	'prop_sizeInputNonNumericValue': '값은 숫자여야 합니다.',
	'prop_sizeValueShouldBeHigher': '값으 %{value}보다 커야 합니다.',
	'fontPropLabel': '글꼴 패밀리',
	'fontSizePropLabel': '글꼴 크기',
	'sectionItemAxisTitle': '항목 축 제목',
	'sectionItemAxisLabel': '항목 축 레이블',
	'sectionValueAxisTitle': '값 축 제목',
	'sectionValueAxisLabel': '값 축 레이블',
	'styletext-widget.legend': '범례',
	'styletext-itemAxis.ticks.labels': '축 레이블',
	'styletext-valueAxis.title': '축 제목',
	'styletext-itemAxis.title': '축 제목',
	'styletext-labels': '데이터 레이블',
	'styletext-valueAxis.line.title': '선 제목',
	'styletext-cellValue': '값',
	'styletext-values': '값',
	'styletext-rowHeading': '행 표제',
	'styletext-columnHeading': '열 표제',
	'fontFamily': '패밀리',
	'fontSize': '크기',
	'visExportFileName': '시각화',
	'ds-missingDataSet': '데이터 세트를 찾을 수 없습니다. 데이터 세트가 작성되었는지 확인하십시오.',
	'ds-missingDashboardId': '데이터 세트를 작성하기 전에 대시보드를 저장하십시오.',
	'ds-unsupportedDataSourceType': '%{type} 데이터 소스 유형은 지원되지 않습니다.',
	'dataCache': '데이터 캐시',
	'dataCache_on': '켜기',
	'dataCache_off': '캐시 없음',
	'dataCache_auto': '자동',
	'queryOptimization': '쿼리 최적화'
});
